<template>
  <div class="m-0 p-0">
    <ValidationProvider v-if="validation" :rules="validation" :vid="field.fieldId" v-slot="{ errors }" :name="name">
      <div class="selectInputWrapper form-group" >
        <select
          class="form-control"
          v-model="localSelected"
          required
          ref="select"
          :name="placeholder"
          :id="field.fieldId"
          @change="updateComponent"
          :class="{'is-invalid': errors.length}"
          :style="styles"
        >
          <option value disabled :selected="!selectedValue" hidden></option>
          <option
            v-for="option in options"
            :key="option.value"
            :selected="option.value == selectedValue"
            :disabled="option.disabled"
            :value="option.value"
          >{{ $t(option.text) }}</option>
        </select>
        <img
          v-if="errors.length"
          class="error_min inputError"
          src="../../assets/icons/risk-icon.svg"
          height="18px"
          width="18px"
          alt
        />
        <span class="floating-label">
          <span v-if="errors.length" class="validation-error">{{errors[0]}}</span>
          <label v-else-if="!localSelected" >{{ $t(placeholder) }} <span v-if="validation.includes('required')">*</span></label>
        </span>
      </div>
    </ValidationProvider>
    <template v-else>
      <div class="selectInputWrapper" :style="`width:${width};`">
        <select
          v-model="localSelected"
          required
          ref="select"
          :name="name"
          :id="field.fieldId"
          @change="updateComponent"
        >
          <option value disabled :selected="!selectedValue" hidden></option>
          <option
            v-for="option in options"
            :key="option.value"
            :selected="option.value == selectedValue"
            :disabled="option.disabled"
            :value="option.value"
          >{{option.text}}</option>
        </select>
        <label class="floating-label">{{placeholder}} <span v-if="required" style="color:#450C10">*</span></label>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "select-input",
  data () {
    return {
      localSelected: this.selectedValue || ""
    };
  },
  props: {
    field: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    selectedValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Select Something"
    },
    width: {
      type: String,
      default: "100%"
    },
    validation: {
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    required: {
      type: Boolean
    },
    customError: {
      type: Boolean
    },
    errorMessage: {
      type: Object,
      default: () => {
        return {
          'gender': 'Geslacht is verplicht'
        }
      }
    }
  },
  mounted () {
    if (this.options.length == 1) {
      this.localSelected = this.options[0].value
      this.updateComponent()
    }
  },
  methods: {
    updateComponent (event) {
      this.$refs.select.style.color = "#000";
      this.$emit("component-updated", {
        text: this.localSelected
      });
      this.$emit("input", this.localSelected);
    }
  }
};
</script>

<style scoped lang="scss">
$medium: 800px;

.selectInputWrapper {
    @media only screen and (max-width: $medium) {
    // margin-left: 30px;
    // margin-right: 20px;
    max-width: 98vw;
  }
  position: relative;
  margin: 5px;
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: #fff url("../../assets/icons/form/dropdown.svg") no-repeat !important;
    background-size: 14px !important;
    background-position: right 10px center !important;
  }
  .inputError {
    position: absolute;
    top: 15px;
    right: 30px;
    z-index: 100;
  }
}

select {
  background: transparent !important;
  outline: 0;
  box-shadow: none;
  transition: border-color 0.15s;
  box-sizing: border-box !important;
  padding-left: 15px !important;
  height: 48px !important;
  cursor: pointer;
  width: 100%;
  &.is-invalid {
    background-color: #fff0f1 !important;
  }
}

.floating-label {
  position: absolute;
  top: 60%;
  left: 10px;
  padding-left: 7px;
  padding-right: 7px;
  transition: transform 0.1s;
  pointer-events: none;
  transform-origin: 0 100%;
  transform: translateY(-50%);
  @media (max-width: 767px) {
    font-size: 12px;
    line-height: 15px;
  }
}

select:focus + .floating-label,
select.visited + .floating-label,
select:not(:focus):valid ~ .floating-label {
  transform: translateY(-140%) scale(0.7);
}

</style>
